const regions = {
  moscow: {
    label: 'Москва',
    codes: [
      '77', '97', '99', '177', '197', '199', '777', '797', '799', '977',
    ],
  },
  moscowRegion: {
    label: 'Московская область',
    codes: ['50', '90', '150', '190', '750', '790'],
  },
  saintPetersburg: {
    label: 'Санкт-Петербург',
    codes: ['78', '98', '178', '198'],
  },
  leningradRegion: {
    label: 'Ленинградская область',
    codes: ['47', '147'],
  },
  altaiRegion: {
    label: 'Алтайский край',
    codes: ['04'],
  },
  amurRegion: {
    label: 'Амурская область',
    codes: ['28'],
  },
  arhangelskRegion: {
    label: 'Архангельская область',
    codes: ['29'],
  },
  astrakhanRegion: {
    label: 'Астраханская область',
    codes: ['30', '130'],
  },
  baikonur: {
    label: 'Байконур',
    codes: ['94'],
  },
  belgorodRegion: {
    label: 'Белгородская область',
    codes: ['31'],
  },
  bryanskRegion: {
    label: 'Брянская область',
    codes: ['32'],
  },
  vladimirRegion: {
    label: 'Владимирская область',
    codes: ['33'],
  },
  volgogradRegion: {
    label: 'Волгоградская область',
    codes: ['34', '134'],
  },
  vologdaRegion: {
    label: 'Вологодская область',
    codes: ['35'],
  },
  voronezhRegion: {
    label: 'Воронежская область',
    codes: ['36', '136'],
  },
  jewishAutonomousRegion: {
    label: 'Еврейская автономная область',
    codes: ['79'],
  },
  transbaikalRegion: {
    label: 'Забайкальский край',
    codes: ['75'],
  },
  ivanovoRegion: {
    label: 'Ивановская область',
    codes: ['37'],
  },
  irkutskRegion: {
    label: 'Иркутская область',
    codes: ['38', '138'],
  },
  kabardinoBalkarianRepublic: {
    label: 'Кабардино-Балкарская Республика',
    codes: ['07'],
  },
  kaliningradRegion: {
    label: 'Калининградская область',
    codes: ['39', '91', '139'],
  },
  kalugaRegion: {
    label: 'Калужская область',
    codes: ['40'],
  },
  kamchatkaKrai: {
    label: 'Камчатский край',
    codes: ['41'],
  },
  kemerovoRegion: {
    label: 'Кемеровская область',
    codes: ['42', '142'],
  },
  kirovRegion: {
    label: 'Кировская область',
    codes: ['43'],
  },
  kostromaRegion: {
    label: 'Костромская область',
    codes: ['44'],
  },
  krasnodarRegion: {
    label: 'Краснодарский край',
    codes: ['23', '93', '123', '193'],
  },
  krasnoyarskRegion: {
    label: 'Красноярский край',
    codes: ['24', '84', '88', '124', '88'],
  },
  kurganRegion: {
    label: 'Курганская область',
    codes: ['45'],
  },
  kurskRegion: {
    label: 'Курская область',
    codes: ['46'],
  },
  lipetskRegion: {
    label: 'Липецкая область',
    codes: ['48'],
  },
  magadanRegion: {
    label: 'Магаданская область',
    codes: ['49'],
  },
  murmanskRegion: {
    label: 'Мурманская область',
    codes: ['51'],
  },
  nenetsAutonomousOkrug: {
    label: 'Ненецкий автономный округ',
    codes: ['83'],
  },
  nizhnyNovgorodRegion: {
    label: 'Нижегородская область',
    codes: ['52', '152'],
  },
  novgorodRegion: {
    label: 'Новгородская область',
    codes: ['53'],
  },
  novosibirskRegion: {
    label: 'Новосибирская область',
    codes: ['54', '154', '754'],
  },
  omskRegion: {
    label: 'Омская область',
    codes: ['55', '155'],
  },
  orenburgRegion: {
    label: 'Оренбургская область',
    codes: ['56', '156'],
  },
  oryolRegion: {
    label: 'Орловская область',
    codes: ['57'],
  },
  penzaRegion: {
    label: 'Пензенская область',
    codes: ['58', '158'],
  },
  permRegion: {
    label: 'Пермский край',
    codes: ['59', '81', '159'],
  },
  primorskyKrai: {
    label: 'Приморский край',
    codes: ['25', '125', '725'],
  },
  pskovRegion: {
    label: 'Псковская область',
    codes: ['60'],
  },
  republicOfAdygea: {
    label: 'Республика Адыгея',
    codes: ['01'],
  },
  altaiRepublic: {
    label: 'Республика Алтай (Горный Алтай)',
    codes: ['22', '122'],
  },
  republicOfBashkortostan: {
    label: 'Республика Башкортостан',
    codes: ['02', '102', '702'],
  },
  republicOfBuryatia: {
    label: 'Республика Бурятия',
    codes: ['03', '103'],
  },
  republicOfDagestan: {
    label: 'Республика Дагестан',
    codes: ['05'],
  },
  republicOfIngushetia: {
    label: 'Республика Ингушетия',
    codes: ['06'],
  },
  republicOfKalmykia: {
    label: 'Республика Калмыкия',
    codes: ['08'],
  },
  republicOfKarachayCherkessia: {
    label: 'Республика Карачаево-Черкессия',
    codes: ['09', '109'],
  },
  republicOfKarelia: {
    label: 'Республика Карелия',
    codes: ['10'],
  },
  komiRepublic: {
    label: 'Республика Коми',
    codes: ['11', '111'],
  },
  republicOfCrimea: {
    label: 'Республика Крым',
    codes: ['82'],
  },
  mariElRepublic: {
    label: 'Республика Марий Эл',
    codes: ['12'],
  },
  republicOfMordovia: {
    label: 'Республика Мордовия',
    codes: ['13', '113'],
  },
  yakutia: {
    label: 'Республика Саха (Якутия)',
    codes: ['14'],
  },
  osetiya: {
    label: 'Республика Северная Осетия Алания',
    codes: ['15'],
  },
  tatarstan: {
    label: 'Республика Татарстан',
    codes: ['16', '116', '716'],
  },
  tyva: {
    label: 'Республика Тыва',
    codes: ['17'],
  },
  khakassia: {
    label: 'Республика Хакасия',
    codes: ['19'],
  },
  rostovRegion: {
    label: 'Ростовская область',
    codes: ['61', '161', '761'],
  },
  ryazanRegion: {
    label: 'Рязанская область',
    codes: ['62'],
  },
  samaraRegion: {
    label: 'Самарская область',
    codes: ['63', '163', '763'],
  },
  saratovRegion: {
    label: 'Саратовская область',
    codes: ['64', '164'],
  },
  sakhalinRegion: {
    label: 'Сахалинская область',
    codes: ['65'],
  },
  sverdlovskRegion: {
    label: 'Свердловская область',
    codes: ['66', '96', '196'],
  },
  sevastopol: {
    label: 'Севастополь',
    codes: ['92', '192'],
  },
  smolenskRegion: {
    label: 'Смоленская область',
    codes: ['67'],
  },
  stavropolRegion: {
    label: 'Ставропольский край',
    codes: ['26', '126'],
  },
  tambovRegion: {
    label: 'Тамбовская область',
    codes: ['68'],
  },
  tverRegion: {
    label: 'Тверская область',
    codes: ['69', '169'],
  },
  tomskRegion: {
    label: 'Томская область',
    codes: ['70'],
  },
  tulaRegion: {
    label: 'Тульская область',
    codes: ['71'],
  },
  tyumenRegion: {
    label: 'Тюменская область',
    codes: ['72	'],
  },
  udmurt: {
    label: 'Удмуртская Республика',
    codes: ['18', '118'],
  },
  ulyanovskRegion: {
    label: 'Ульяновская область',
    codes: ['73', '173'],
  },
  khabarovskRegion: {
    label: 'Хабаровский край',
    codes: ['27'],
  },
  khantyMansiysk: {
    label: 'Ханты-Мансийский автономный округ - Югра',
    codes: ['86', '186'],
  },
  chelyabinskRegion: {
    label: 'Челябинская область',
    codes: ['74', '174', '774'],
  },
  chechenRepublic: {
    label: 'Чеченская республика',
    codes: ['95'],
  },
  chuvashRepublic: {
    label: 'Чувашская Республика',
    codes: ['21', '121'],
  },
  chukotka: {
    label: 'Чукотский автономный округ',
    codes: ['87'],
  },
  yamaloNenets: {
    label: 'Ямало-Ненецкий автономный округ',
    codes: ['89'],
  },
  yaroslavlRegion: {
    label: 'Ярославская область',
    codes: ['76'],
  },
  dpr: {
    label: 'ДНР',
    codes: ['80', '180'],
  },
  lpr: {
    label: 'ЛНР',
    codes: ['81', '181'],
  },
  kherson: {
    label: 'Херсонская область',
    codes: ['84', '184'],
  },
  zaporozhie: {
    label: 'Запорожская область',
    codes: ['85', '185'],
  },
  outside: {
    label: 'Вне РФ',
    codes: ['94'],
  },
};

export default regions;
